import apiWrapper from '@/utils/apiHelpers/apiWrapper'

const getConfigs = () => apiWrapper.get('configs/all')

const getConfig = (configKey, configs) => (configs.all || {})[configKey]

const configHelper = {
  getConfigs,
  getConfig
}

export default configHelper
